import { render } from "./PortMappingModal.vue?vue&type=template&id=28b5732e&scoped=true&ts=true"
import script from "./PortMappingModal.vue?vue&type=script&lang=ts"
export * from "./PortMappingModal.vue?vue&type=script&lang=ts"

import "./PortMappingModal.vue?vue&type=style&index=0&id=28b5732e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b5732e"]])

export default __exports__